import React from 'react';
import TFFTypography from '../../styled-components/TFFTypography';
import { useBookingContext } from '../../hooks/use-booking-context';

interface props {
  flexData: any;
}

const FlexOptionFooter: React.FC<props> = ({ flexData }) => {
  const { numberFormatter } = useBookingContext();

  const productSum = flexData?.passengers.reduce((sum, passenger) => sum + (passenger.productPrice || 0), 0);
  const referredSum = flexData?.passengers.reduce((sum, passenger) => sum + (passenger.referredPrice || 0), 0);
  const refundSum = flexData?.passengers.reduce((sum, passenger) => sum + (passenger.refundPrice || 0), 0);

  return (
    <>
      <div
        id="flex-columns"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 1fr)',
          gap: '18px',
          borderTop: '1px solid black',
          borderBottom: '1px solid var(--color-functional-neutral-400)',
          backgroundColor: '#E3F5FD',
          padding: '8px 0px 8px 18px',
        }}
      >
        <TFFTypography
          color="color-functional-neutral-900"
          fontWeight="bold"
          text={'TOTAL FLEX'}
          extraStyle={{ textAlign: 'start' }}
        />
        <TFFTypography
          color="color-functional-neutral-900"
          fontWeight="bold"
          text={numberFormatter.format(productSum)}
          extraStyle={{ textAlign: 'end', gridColumn: '3' }}
        />
        <TFFTypography
          color="color-functional-neutral-900"
          fontWeight="bold"
          text={numberFormatter.format(referredSum)}
          extraStyle={{ textAlign: 'end' }}
        />
        <TFFTypography
          color="color-functional-neutral-900"
          fontWeight="bold"
          text={`${flexData?.productParameters.refundPercentage}%`}
          extraStyle={{ whiteSpace: 'nowrap', textAlign: 'end' }}
        />

        <TFFTypography
          color="color-functional-neutral-900"
          fontWeight="bold"
          text={numberFormatter.format(refundSum)}
          extraStyle={{ whiteSpace: 'nowrap', textAlign: 'end' }}
        />
      </div>
    </>
  );
};

export default FlexOptionFooter;
